import React, { useEffect, useState } from 'react';

import { setDialogCardAnalytics } from 'store/analytics';
import { trackPageView } from 'store/analytics/analytics.thunks';
import { useAppDispatch } from 'store/store';

import DialogueCard from './DialogueCard/DialogueCard';
import { useDialogueCard } from './hooks/DialogueCard.hooks';

const DialogueCardPanel: React.FC = () => {
  const dialogueCardData = useDialogueCard();
  const dispatch = useAppDispatch();
  const [pageTracked, setPageTracked] = useState(false);

  useEffect(() => {
    if (!dialogueCardData || pageTracked) return;
    dispatch(setDialogCardAnalytics(dialogueCardData.analyticsId));
    dispatch(trackPageView('details'));
    setPageTracked(true);
    if (!dialogueCardData.type) return;
  }, [dispatch, dialogueCardData, pageTracked]);

  return <DialogueCard dialogueCard={dialogueCardData} />;
};

export default DialogueCardPanel;
